import React, { useEffect, useState } from 'react';
import { getAllVehicles, getVehicles } from '../../service/api/Vehicle/apiVehicle';
import { VehicleSheet } from '../../components/VehicleManagement/VehicleSheet';
import { Message } from '../../components';
import { useUser } from '../../hooks/useUser';
import { roleConfig } from '../../constants/roleConfig';

const VehicleManagement = () => {
    const [vehicles, setVehicles] = useState([]);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const { id, companyId, role } = useUser();

    useEffect(() => {
        loadVehicles();
    }, [refreshTrigger]);

    const loadVehicles = async () => {
        let queryParams = null;
        let response = null;
        try {
            if (role === roleConfig['主管']) {
                queryParams = companyId ? { companyId } : { employeeId: id };
            } else if (role === roleConfig['員工']) {
                queryParams = companyId ? { companyId } : { employeeId: id };
            }
            response = await getVehicles(queryParams);
            if (response?.status === 200) {
                setVehicles(response.data.result);
            }
        } catch (error) {
            console.error('載入車輛失敗:', error);
            Message('載入車輛失敗', 'error');
        }
    };

    const handleRefresh = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    return (
        <>
            <div className="vehiclemanagement container mt-4">
                <div className="card shadow p-4 border-0">
                    <h4 className="mb-3 text-primary fw-bold">車輛管理</h4>
                    <div className="col-lg-12 mb-4">
                        <div className="card">
                            <VehicleSheet
                                data={vehicles}
                                onRefresh={handleRefresh}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { VehicleManagement };
